<template>
    <div>
        <loading size="sm" v-if="loading === true"/>
        <titan-form :schema="schema"
                    :newItem="createNew"
                    :model="$store.state.templates.item"
                    v-on:saveData="saveData()"
                    v-if="loading === false"
        />
    </div>
</template>
<script>
    import TitanForm from '../../../core/Form/Form'
    import VueFormGenerator from "vue-form-generator";
    import Loading from '../../../core/Components/loading';

    export default {
        components: {
            Loading,
            TitanForm
        },
        props: {
            createNew: {
                type: Boolean,
                default: true,
            },
            visibleIdentifier: {
                type: Boolean,
                default: true,
            },
            disabledIdentifier: {
                type: Boolean,
                default: true,
            },
            type: {
                type: String,
                default: 'mail',
            },
            id: {
                type: Number | null,
                default: null,
            },
            textInputType: {
                type: String,
                default: 'titanRedactor',
            }
        },
        mounted() {
            if (this.createNew) {
                this.$store.commit('templates/resetItem');
                this.loading = false;
            } else {
                this.loading = true;
                this.$store.dispatch('templates/get', this.id).then(response => {
                    this.loading = false;
                });
            }
        },
        methods: {
            saveData() {
                this.$store.state.templates.item.type = this.type;
                this.$store.dispatch(
                    this.createNew ? 'templates/create' : 'templates/update',
                    this.$store.state.templates.item
                ).then(response => {
                    this.$emit('saved', response);
                });
            }
        },
        data() {
            return {
                loading: true,
                schema: [
                    {
                        name: this.createNew ? this.t('Create template') : this.t('Update template'),
                        type: 'main',
                        fields: [
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Identifier'),
                                model: 'identificator',
                                required: true,
                                disabled: () => {
                                    return this.disabledIdentifier;
                                },
                                visible: () => {
                                    return this.visibleIdentifier;
                                },
                                validator: VueFormGenerator.validators.required
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Subject'),
                                model: 'name',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            }, {
                                type: this.textInputType,
                                label: this.t('Text'),
                                model: 'text',
                                rows: 4,
                                required: true,
                                validator: VueFormGenerator.validators.required
                            }, {
                                type: 'titanSwitch',
                                label: this.t('Active'),
                                model: 'active'
                            }
                        ]
                    }
                ]
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/admin/Pages/Templates/Manage.vue